module.exports = __webpack_public_path__ + "img/s21.09a46e3.png";